import {post, downFile, postfile} from './http'
const baseUrl = '/api/admin/mktools/ass'

// 核销员
// 获取核销员列表
export const getAssVerifierinfoList = v => post(`${baseUrl}/getAssVerifierinfoList`, v.data, v.success, v.error)

// 获取 可以绑定的 核销员列表
export const searchVerifierInfo = v => post(`${baseUrl}/searchAssVerifierInfo`, v.data, v.success, v.error)

// 新增核销员
export const saveVerifier = v => post(`${baseUrl}/saveAssVerifier`, v.data, v.success, v.error)

// 删除核销员
export const deleteVerifier = v => post(`${baseUrl}/deleteAssVerifier`, v.data, v.success, v.error)

// 订单核销
// 获取已核销订单列表
export const getAssEventCheckOrderList = v => post(`${baseUrl}/getAssEventCheckOrderList`, v.data, v.success, v.error)

// 确认核销
export const updateAssEventOrderByCheck = v => post(`${baseUrl}/updateAssEventOrderByCheck`, v.data, v.success, v.error)

// 查询订单详情
export const getOrderInfoByLineCode = v => post(`${baseUrl}/getOrderInfoByLineCode`, v.data, v.success, v.error)

// 助力活动管理
// 删除活动兑换码
export const deleteAssEventExchangeCode = v => post(`${baseUrl}/deleteAssEventExchangeCode`, v.data, v.success, v.error)

// 删除助力海报
export const deleteAssEventPoster = v => post(`${baseUrl}/deleteAssEventPoster`, v.data, v.success, v.error)

// 导出兑换码
export const exportAssExchangeCode = v => post(`${baseUrl}/exportAssExchangeCode`, v.data, v.success, v.error)

// 查询助力活动详情
export const getAssEventInfo = v => post(`${baseUrl}/getAssEventInfo`, v.data, v.success, v.error)

// 查询助力活动列表
export const getAssEventList = v => post(`${baseUrl}/getAssEventList`, v.data, v.success, v.error)

// 获取单个助力海报
export const getAssEventPosterInfo = v => post(`${baseUrl}/getAssEventPosterInfo`, v.data, v.success, v.error)

// 获取助力海报列表
export const getAssEventPosterList = v => post(`${baseUrl}/getAssEventPosterList`, v.data, v.success, v.error)

// 助力排行榜
export const getAssEventRankList = v => post(`${baseUrl}/getAssEventRankList`, v.data, v.success, v.error)

// 查询客服消息配置详情
export const getAssEventServiceMessageInfo = v => post(`${baseUrl}/getAssEventServiceMessageInfo`, v.data, v.success, v.error)

// 查询助力分享设置详情
export const getAssEventShareSettingInfo = v => post(`${baseUrl}/getAssEventShareSettingInfo`, v.data, v.success, v.error)

// 获取活动兑换码列表
export const getAssExchangeCodeList = v => post(`${baseUrl}/getAssExchangeCodeList`, v.data, v.success, v.error)

// 导入兑换码
export const importAssExchangeCode = v => post(`${baseUrl}/importAssExchangeCode`, v.data, v.success, v.error)

// 保存新增或编辑助力活动
export const saveOrUpdateAssEventInfo = v => postfile(`${baseUrl}/saveOrUpdateAssEventInfo`, v.data, v.success, v.error)

// 保存新增或编辑助力海报
export const saveOrUpdateAssEventPoster = v => post(`${baseUrl}/saveOrUpdateAssEventPoster`, v.data, v.success, v.error)

// 保存客服消息配置
export const updateAssEventServiceMessage = v => post(`${baseUrl}/updateAssEventServiceMessage`, v.data, v.success, v.error)

// 保存编辑助力分享设置
export const updateAssEventShareSettingInfo = v => post(`${baseUrl}/updateAssEventShareSettingInfo`, v.data, v.success, v.error)

// 修改活动状态
export const updateAssEventStatus = v => post(`${baseUrl}/updateAssEventStatus`, v.data, v.success, v.error)



